<template>
    <div class="serial-manager">
        <div class="tabs">
            <div class="tab-container" :class="{active: createSerialTabActive}" v-if="inEditWorkMode">
                <div class="tab" @click="setActiveTab(tabCreateSerial)">Bind New Serial</div>
            </div>
            <div class="tab-container" :class="{active: findSerialTabActive}">
                <div class="tab" @click="setActiveTab(tabFindSerial)">Find a Serial</div>
            </div>
        </div>
        <div class="tab-contents">
            <div class="tab-content" v-if="createSerialTabActive">
                <button @click="createSerialAndBind"
                        class="section-control ml-auto button-primary edit-involved-button">Create New Serial and Bind
                </button>
            </div>
            <div class="tab-content" v-show="findSerialTabActive">
                <form class="search-panel" @submit.prevent="submitSearch">
                    <div class="search-input-wrapper">
                        <input ref="input" name="serialId" placeholder="Enter Serial ID..."
                               @focus="onInputFocus"
                               class="section-control flex-grow-1"
                               spellcheck="false" autocomplete="off">
                        <i class="gf gf-search" @click="submitSearch"></i>
                    </div>
                </form>
                <serial-box ref="serialBox"
                        :can-edit="canEdit" :parent-document-object="parentDocumentObject"
                            :serial-id="serialId">
                </serial-box>
            </div>
        </div>
    </div>
</template>

<script>

    import {userSettingsManager, workModeEdit, workModeRead} from "@/utils";
    import SerialBox from "@/components/SerialBox";

    const tabCreateSerial = 'create_serial';
    const tabFindSerial = 'find_serial';

    export default {
        name: "DTSerialManager",
        components: {SerialBox},
        methods: {
            focus() {
                if (this.findSerialTabActive) {
                    this.$refs.input.focus();
                }
            },
            createSerialAndBind() {
                this.$emit('createSerialAndBind')
            },
            setActiveTab(tab) {
                if (tab === this.activeTab) {
                    return;
                }

                this.activeTab = tab;

                if (tab === tabFindSerial) {
                    this.$nextTick(() => {
                        this.$refs.input.focus()
                    })
                }
            },
            submitSearch() {
                this.serialId = this.$refs.input.value.trim();
            },
            reload() {
                this.$refs.serialBox.findSerial();
            },
            revealSerialId(serialId) {
                this.setActiveTab(tabFindSerial);
                this.$refs.input.value = serialId;
                this.serialId = serialId;
                this.$refs.serialBox.findSerial();
                this.$nextTick(() => {
                    this.$refs.serialBox.focus();
                })
            },
            onInputFocus(event) {
                const target = event.currentTarget;
                target.selectionStart = 0;
                target.selectionEnd = target.value.length;
            },
            resetInitial() {
                this.serialId = null;
            },
        },
        data() {
            return {
                tabCreateSerial: tabCreateSerial,
                tabFindSerial: tabFindSerial,
                activeTab: null,
                serialId: null,
            }
        },
        props: {
            parentDocumentObject: Object,
            canEdit: Boolean,
        },
        computed: {
            workMode() {
                return userSettingsManager.getWorkMode();
            },
            inEditWorkMode() {
                return this.workMode === workModeEdit;
            },
            inReadWorkMode() {
                return this.workMode === workModeRead;
            },
            createSerialTabActive() {
                return this.activeTab === tabCreateSerial;
            },
            findSerialTabActive() {
                return this.activeTab === tabFindSerial;
            }
        },
        watch: {
            workMode: {
                handler(newVal) {
                    if (newVal === workModeRead) {
                        this.setActiveTab(tabFindSerial);
                    } else if (this.activeTab === null) {
                        this.setActiveTab(tabCreateSerial);
                    }
                },
                immediate: true,
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/variables";

    .serial-manager {

    }

    .sections {
        section {
            margin: 1.5rem 0;

            .section-label {
                font-size: 1rem;
                margin-bottom: 1rem;
                display: flex;
                align-items: center;
            }
        }
    }

    .search-panel {
        margin-bottom: 1.5rem;
        .search-input-wrapper {
            display: flex;
            align-items: center;
            position: relative;

            input {
                flex: 1 auto;
                padding-right: 1.2rem;
            }

            i {
                position: absolute;
                right: 0.2rem;
                color: gray;
                font-size: 1.1em;
                cursor: pointer;
            }
        }
    }

    .tabs {
        display: flex;
        align-items: center;
        margin-bottom: 1.5rem;

        .tab-container {
            &:not(:last-child) {
                margin-right: 0.8rem;
                padding-right: 0.8rem;
                border-right: 1px solid gray;
            }

            .tab {
                font-size: 1.15em;
                font-weight: 500;
                cursor: pointer;
                user-select: none;
            }

            &.active:not(:only-child) {
                .tab {
                    cursor: default;
                    color: $primary-blue;
                }
            }
        }
    }
</style>
